import React from "react";
import styled from "styled-components";
import { ScaleIn } from "./AnimatedComponents";

interface ContactItemProps {
  title: string;
  icon: React.ReactNode;
  cont1: string;
  cont2: string;
}

const ContactItem: React.FC<ContactItemProps> = ({
  title,
  icon,
  cont1,
  cont2,
}) => {
  return (
    <ScaleIn>
      <ContactItemStyled>
        <div className="icon-wrapper">{icon}</div>
        <div className="info">
          <h6>{title}</h6>
          <p>{cont1}</p>
          {cont2 && <p>{cont2}</p>}
        </div>
      </ContactItemStyled>
    </ScaleIn>
  );
};

const ContactItemStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 1.25rem;
  padding: 1.5rem;
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  border-radius: 12px;
  transition: all 0.3s ease;

  &:not(:last-child) {
    margin-bottom: 1.25rem;
  }

  &:hover {
    border-color: var(--card-hover-border);
    transform: translateY(-2px);
    box-shadow: var(--shadow-md);
  }

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 3rem;
    border-radius: 10px;
    background: var(--background-light-color-2);
    color: var(--primary-color);
    flex-shrink: 0;

    svg {
      width: 1.25rem;
      height: 1.25rem;
    }
  }

  .info {
    h6 {
      font-size: 1rem;
      font-weight: 600;
      margin-bottom: 0.25rem;
    }

    p {
      font-size: 0.875rem;
      color: var(--font-light-color);
      padding: 0.1rem 0;
    }
  }
`;

export default ContactItem;
